export default "__VITE_ASSET__95347463__"